import { Chip } from '@mui/material';

type MenuTagProps = {
  label: string;
};

export default function MenuTag({ label }: MenuTagProps) {
  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: '#06CB3F',
        color: '#FFF',
        marginLeft: 2,
        fontWeight: 'bold',
        borderRadius: '999px',
        '& .MuiChip-label': {
          px: 1
        },
      }}
    />
  );
}